<template>
  <ckeditor :editor="editor" v-model="formData.content" :config="editorConfig" @ready="prefill"></ckeditor>
</template>

<script>

import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import SimpleUploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter';

import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize';
import LinkImage from '@ckeditor/ckeditor5-link/src/linkimage';
import ImageInsert from '@ckeditor/ckeditor5-image/src/imageinsert';

import HtmlEmbed from '@ckeditor/ckeditor5-html-embed/src/htmlembed';

import HorizontalLine from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline';
import Highlight from '@ckeditor/ckeditor5-highlight/src/highlight';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Font from '@ckeditor/ckeditor5-font/src/font';
import ListStyle from '@ckeditor/ckeditor5-list/src/liststyle';
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice';
import Clipboard from '@ckeditor/ckeditor5-clipboard/src/clipboard';
import Table from '@ckeditor/ckeditor5-table/src/table';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar';
import TableProperties from '@ckeditor/ckeditor5-table/src/tableproperties';
import TableCellProperties from '@ckeditor/ckeditor5-table/src/tablecellproperties';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import CodeBlock from '@ckeditor/ckeditor5-code-block/src/codeblock';
import SpecialCharacters from '@ckeditor/ckeditor5-special-characters/src/specialcharacters';
// A plugin that combines a basic set of special characters.
import SpecialCharactersEssentials from '@ckeditor/ckeditor5-special-characters/src/specialcharactersessentials';
import SourceEditing from '@ckeditor/ckeditor5-source-editing/src/sourceediting';

export default {
  props: {
    contentSet: String,
  },
  data() {
    return {
      formData: { content:'' },
      editor: ClassicEditor,
      editorData: '',
      editorConfig: {
        plugins: [
          EssentialsPlugin,
          BoldPlugin,
          ItalicPlugin,
          LinkPlugin,
          ParagraphPlugin,
          Alignment,
          SimpleUploadAdapter,
          // CKFinder,
          Image, ImageToolbar, ImageCaption, ImageStyle, ImageResize, LinkImage,ImageInsert,
          HtmlEmbed,
          HorizontalLine,
          Highlight,
          Heading,
          Font,
          ListStyle,
          MediaEmbed,
          PasteFromOffice,
          Clipboard,
          Table, TableToolbar, TableProperties, TableCellProperties,
          BlockQuote,
          CodeBlock,
          SpecialCharacters, SpecialCharactersEssentials,
          SourceEditing
        ],

        toolbar: {
          items: [
            'sourceEditing',
            'heading',
            '|','fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor','|',
            'bulletedList', 'numberedList','blockQuote',
            'codeBlock',
            'specialCharacters','|',
            '-', // break point
            'bold',
            'italic',
            'link',
            'undo',
            'redo',
            'alignment',
           // '-', // break point
            //'ckfinder', //'uploadImage'

            'imageStyle:full',
            'imageStyle:side',
            '|',
            'imageTextAlternative',
            '|',
            'linkImage',
            //'uploadImage',
            'insertImage',
            'insertTable',
            'mediaEmbed',
            'htmlEmbed',
            'horizontalLine',
            'highlight'

            //'imageStyle:alignLeft', 'imageStyle:alignCenter', 'imageStyle:alignRight',
          ],
          shouldNotGroupWhenFull: true
        },
        fontColor: {
          colors: this.getColorTable(),
          columns: 8,
          documentColors: 10,
        },
        fontBackgroundColor: {
          colors: this.getColorTable(),
          columns: 8,
          documentColors: 10,
        },
        simpleUpload: {
          // The URL that the images are uploaded to.
          //uploadUrl: 'http://localhost:3456/_api/common/upload-ckeditor',
          uploadUrl: this.$ConfigEvn.base_url_api+'/_api/common/upload-s3-ckeditor',

          // Enable the XMLHttpRequest.withCredentials property.
          withCredentials: false,

          // Headers sent along with the XMLHttpRequest to the upload server.
          headers: {
            //'X-CSRF-TOKEN': 'CSRF-Token',
            //Authorization: 'asdasdasdasdasdsad'
            "Authorization": "Bearer "+this.$store.getters.token,
          }
        },
        image: {
          // Configure the available styles.
          styles: [
            'alignLeft', 'alignCenter', 'alignRight'
          ],

          // Configure the available image resize options.
          resizeOptions: [
            {
              name: 'resizeImage:original',
              label: 'Original',
              value: null
            },
            {
              name: 'resizeImage:50',
              label: '50%',
              value: '50'
            },
            {
              name: 'resizeImage:75',
              label: '75%',
              value: '75'
            }
          ],

          // You need to configure the image toolbar, too, so it shows the new style
          // buttons as well as the resize buttons.
          toolbar: [
            'toggleImageCaption',
            'imageStyle:alignLeft', 'imageStyle:alignCenter', 'imageStyle:alignRight',
            '|',
            'resizeImage',
            '|',
            'imageTextAlternative'
          ]
        },
        fontSize: {
          options: [
            9,10,11,12,14,16,'default',18,20,22,28
          ]

        },
        table: {
          contentToolbar: [
            'tableColumn', 'tableRow', 'mergeTableCells',
            'tableProperties', 'tableCellProperties'
          ],

          tableProperties: {
            borderColors: this.getColorTable(),
            backgroundColors: this.getColorTable()
          },

          // Set the palettes for table cells.
          tableCellProperties: {
            borderColors: this.getColorTable(),
            backgroundColors: this.getColorTable()
          }
        }
      },
    }
  },
  created() {
    // console.log("this.contentSetthis.contentSet",this.contentSet);
   // this.formData.content = this.contentSet;
  },
  watch: {
    formData: {
      handler: function() {
        this.$emit('newdata', [this.formData.content]);
      },
      deep: true
    },
    /*contentSet:{
      handler: function() {
        console.log("this.contentSet1111",this.contentSet);
        this.formData.content = this.contentSet;
      },
      deep: true
    }*/

  },
  // watch: {
  //   '$route': 'initParams'
  // },
  methods: {
    prefill( ) {
      this.formData.content = this.contentSet;
    },
    getColorTable(){
      const customColorPalette = [
    { color: 'hsl(4, 90%, 58%)', label: 'Red' },
    { color: 'hsl(340, 82%, 52%)', label: 'Pink' },
    { color: 'hsl(291, 64%, 42%)', label: 'Purple' },
    { color: 'hsl(262, 52%, 47%)', label: 'Deep Purple' },
    { color: 'hsl(231, 48%, 48%)', label: 'Indigo' },
    { color: 'hsl(207, 90%, 54%)', label: 'Blue' },
    { color: 'hsl(187, 100%, 42%)', label: 'Cyan' },
    { color: 'hsl(174, 62%, 47%)', label: 'Teal' },
    { color: 'hsl(122, 39%, 49%)', label: 'Green' },
    { color: 'hsl(88, 50%, 53%)', label: 'Light Green' },
    { color: 'hsl(66, 70%, 61%)', label: 'Lime' },
    { color: 'hsl(54, 100%, 62%)', label: 'Yellow' },
    { color: 'hsl(43, 90%, 58%)', label: 'Amber' },
    { color: 'hsl(36, 100%, 50%)', label: 'Orange' },
    { color: 'hsl(14, 100%, 57%)', label: 'Deep Orange' },
    { color: 'hsl(0, 0%, 100%)', label: 'White', hasBorder: true },
    { color: 'hsl(0, 0%, 0%)', label: 'Black' },
    { color: 'hsl(0, 0%, 53%)', label: 'Grey' },
    { color: 'hsl(0, 0%, 70%)', label: 'Light Grey' },
    { color: 'hsl(0, 5%, 95%)', label: 'Very Light Grey' },
    { color: 'hsl(291, 100%, 80%)', label: 'Lavender' },
    { color: 'hsl(33, 100%, 85%)', label: 'Peach' },
    { color: 'hsl(174, 50%, 75%)', label: 'Mint' },
    { color: 'hsl(208, 100%, 85%)', label: 'Sky Blue' },
    { color: 'hsl(348, 100%, 85%)', label: 'Rose' },
    { color: 'hsl(48, 100%, 85%)', label: 'Sunflower' },

    // New colors
    { color: 'hsl(220, 60%, 50%)', label: 'Royal Blue' },
    { color: 'hsl(120, 60%, 50%)', label: 'Forest Green' },
    { color: 'hsl(180, 80%, 60%)', label: 'Turquoise' },
    { color: 'hsl(240, 50%, 70%)', label: 'Slate Blue' },
    { color: 'hsl(200, 100%, 60%)', label: 'Dodger Blue' },
    { color: 'hsl(250, 80%, 60%)', label: 'Medium Purple' },
    { color: 'hsl(10, 100%, 40%)', label: 'Crimson' },
    { color: 'hsl(40, 100%, 50%)', label: 'Goldenrod' },
    { color: 'hsl(110, 60%, 45%)', label: 'Olive Green' },
    { color: 'hsl(0, 100%, 50%)', label: 'Firebrick' },
    { color: 'hsl(10, 80%, 70%)', label: 'Salmon' },
    { color: 'hsl(290, 70%, 60%)', label: 'Violet' },
    { color: 'hsl(60, 100%, 50%)', label: 'Yellow Green' },
    { color: 'hsl(330, 100%, 50%)', label: 'Magenta' },
    { color: 'hsl(320, 100%, 60%)', label: 'Fuchsia' },
    { color: 'hsl(190, 100%, 45%)', label: 'Aquamarine' },
    { color: 'hsl(150, 50%, 40%)', label: 'Sea Green' },
    { color: 'hsl(350, 50%, 60%)', label: 'Orchid' },
    { color: 'hsl(300, 100%, 40%)', label: 'Medium Orchid' },
    { color: 'hsl(60, 100%, 70%)', label: 'Light Yellow' },
    { color: 'hsl(170, 50%, 60%)', label: 'Light Teal' },
    { color: 'hsl(40, 100%, 70%)', label: 'Light Amber' },
    { color: 'hsl(250, 50%, 60%)', label: 'Lavender Blue' },
    { color: 'hsl(110, 80%, 50%)', label: 'Spring Green' },
    { color: 'hsl(30, 100%, 60%)', label: 'Peach Puff' },
    { color: 'hsl(190, 100%, 60%)', label: 'Sky Cyan' },
    { color: 'hsl(70, 100%, 50%)', label: 'Chartreuse' },
    { color: 'hsl(60, 100%, 60%)', label: 'Lemon' },
    { color: 'hsl(190, 100%, 80%)', label: 'Powder Blue' },
    { color: 'hsl(90, 100%, 80%)', label: 'Mint Cream' },
    { color: 'hsl(10, 80%, 85%)', label: 'Light Coral' },
    { color: 'hsl(180, 80%, 60%)', label: 'Caribbean Green' },
    { color: 'hsl(300, 60%, 70%)', label: 'Pink Orchid' },
    { color: 'hsl(330, 80%, 65%)', label: 'Crimson Red' },
    { color: 'hsl(60, 100%, 40%)', label: 'Golden Yellow' },
    { color: 'hsl(50, 90%, 45%)', label: 'Olive' },
    { color: 'hsl(160, 70%, 60%)', label: 'Jade Green' },
    { color: 'hsl(10, 50%, 50%)', label: 'Indian Red' },
    { color: 'hsl(220, 60%, 40%)', label: 'Steel Blue' },
    { color: 'hsl(0, 0%, 50%)', label: 'Gray' },
    { color: 'hsl(120, 100%, 40%)', label: 'Bright Green' },
    { color: 'hsl(50, 100%, 60%)', label: 'Lemon Yellow' },
    { color: 'hsl(20, 90%, 60%)', label: 'Orange Red' },
    { color: 'hsl(210, 100%, 50%)', label: 'Blue Green' },
    { color: 'hsl(180, 70%, 70%)', label: 'Pastel Cyan' },
    { color: 'hsl(30, 100%, 40%)', label: 'Amber Yellow' },
    { color: 'hsl(120, 50%, 60%)', label: 'Moss Green' },
    { color: 'hsl(160, 60%, 50%)', label: 'Seafoam Green' },
    { color: 'hsl(250, 50%, 50%)', label: 'Purple Red' },
    { color: 'hsl(130, 60%, 70%)', label: 'Tea Green' },
    { color: 'hsl(150, 50%, 60%)', label: 'Apple Green' }
];

      return customColorPalette;
    }

  },
}
</script>
<style lang="scss">
.ck-content{
  h2{
    font-size: 2rem !important;
  }
}
</style>

